import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

import { TKeys } from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors.utils';
import {
    IActivityTypeOptions,
    activityTypeOptions,
    statusOptions,
} from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan.utils';

interface Props {
    activityTypeFilter: readonly IActivityTypeOptions[];
    statusFilter: readonly ISelectOption<string>[];
    isCriticalPath: boolean;
    submittedCompletionFilter: number[];
    activeTab: TKeys;
    isDelayDriver: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    activityTypeFilter: activityTypeOptions,
    statusFilter: statusOptions,
    isCriticalPath: false,
    submittedCompletionFilter: [0, 100],
    activeTab: 'blocking',
    isDelayDriver: false,
    update: (value) => set({ ...value }),
});

export const useActivitiesCompletionPlanStore = create(state);
